import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { updateScholarshipProvider } from "../../services/school/scholarshipProvider";
import { ScholarshipProviderType } from "../../types/ScholarshipProviderType";
import { ScholarshipProviderFormValidation } from "./ScholarshipProviderFormValidation";
import { resetScholarshipProviderData } from "../../redux/slices/school/scholarshipProvider";

export const UpdateScholarshipProvider = () => {
    const navigate = useNavigate();
    const mutation = useMutation({ mutationFn: updateScholarshipProvider, mutationKey: "updateScholarshipProvider" });
    const data = useAppSelector((state) => state.scholarshipProvider);
    const dispatch = useAppDispatch();

    const { control, handleSubmit, formState: { errors } } = useForm<ScholarshipProviderType>({
        resolver: yupResolver(ScholarshipProviderFormValidation),
        defaultValues: data,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
    });

    const onSubmit = handleSubmit(async (data) => {
        try {
            const result = await mutation.mutateAsync(data);
            if (result) {
                toast.success("Provedor de Bolsa atualizado!");
                navigate(routes.scholarshipProviders);
            }
        } catch (err: any) {
            toast.error(`${mutation.error ?? err?.message}`);
        }
    });

    const handleBack = () => {
        dispatch(resetScholarshipProviderData());
        navigate(routes.scholarshipProviders);
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size="1">
                <Flex direction="column" gap="4">
                    <TextFieldComponent name="description" label="Nome" control={control} errors={errors} required={true} />
                    <TextFieldComponent name="code" label="Código" control={control} errors={errors} />
                    <TextFieldComponent name="internalCode" label="Código Interno" control={control} errors={errors} />
                    <Flex direction="row" gap="4" style={{ alignSelf: 'end' }}>
                        <Button color="red" onClick={handleBack} disabled={mutation.isLoading}>
                            <ChevronLeftIcon /> Voltar
                        </Button>
                        <Button type="submit" disabled={mutation.isLoading} variant="surface">
                            {mutation.isLoading ? <Spinner loading><EnterIcon /></Spinner> : <EnterIcon />}
                            Registrar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
